import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Title } from '@common/components';

import statsCardClasses from './StatsCard.module.scss';

export default function StatsCard({ className, children }) {
  const cn = cx(statsCardClasses.statsCard, className);
  return <div className={cn}>{children}</div>;
}

export function StatsCardHeader({ className, children }) {
  const cn = cx(statsCardClasses.header, className);
  return (
    <div className={cn}>
      <Title
        type="h2"
        color="font-secondary"
        className={statsCardClasses.statstitle}
      >
        {children}
      </Title>
    </div>
  );
}
export function StatsCardBody({ className, children }) {
  const cn = cx(statsCardClasses.body, className);
  return <div className={cn}>{children}</div>;
}
export function StatsCardItem({ className, text, data }) {
  const cn = cx(statsCardClasses.item, className);
  return (
    <div className={cn}>
      <Title type="p" color="grey-400" className={statsCardClasses.itemText}>
        {text}
      </Title>
      <Title type="span" color="accent" className={statsCardClasses.itemData}>
        {data}
      </Title>
    </div>
  );
}
StatsCard.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

StatsCardHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
StatsCardBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
StatsCardItem.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
